import { GuardError } from '../../errors/GuardError';
import { registerWsSession } from '../../actions/wsSession';
import { setSessionFailed, setSessionPending, setSessionSucceed } from '../../slices/sessionSlice';
import { setUserId } from '../../slices/userSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { fetchUsersSession } from '../fetchUsersSession';

// Одна минута в секундах
const ONE_MINUTE = 60;

/**
 * Получить token сессии
 */
export const checkUsersSession = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { logger, telemetry } = context;
  const {
    session: { token },
  } = getState();

  const timezone = -(new Date().getTimezoneOffset() / ONE_MINUTE);

  dispatch(setSessionPending());

  try {
    const session = await fetchUsersSession(context, { timezone });

    if (!session) {
      dispatch(setSessionFailed());

      telemetry.increment(ETelemetryEvents.ChatWsTokenError);

      const exception = new GuardError({
        domain: EExceptionDomain.UserSession,
        message: 'Получен пустой токен',
      });

      logger.warning(exception);

      return;
    }

    telemetry.increment(ETelemetryEvents.ChatWsTokenSuccess);
    dispatch(setSessionSucceed(session));
    dispatch(setUserId(session.userId));

    if (token?.sessionToken && token.sessionToken !== session.sessionToken) {
      await dispatch(registerWsSession());
    }
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatWsTokenError);

    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.UserSession,
      message: 'Не удалось проверить токен сессии',
    });

    logger.error(errorToLog, { timezone });

    dispatch(setSessionFailed());
  }
};
